<div class="icon-tile" (click)="ellipsisClickEventEmitter.emit($event)">
  <div class="icon-tile-icon" [style.background-color]="iconBackgroundColor">
    <ion-img [src]="icon"></ion-img>
  </div>
  <div class="icon-tile-content">
    <div class="title">{{ title }}</div>
    <div class="description">{{ description }}</div>
  </div>
  <div class="icon-tile-ellipsis" *ngIf="showEllipsis">
    <ion-icon
      name="chevron-forward-outline"
      [style.color]="chevronColor"
    ></ion-icon>
  </div>
</div>
